export default __webpack_public_path__ + "static/media/user_kris.fdad5ceb.png";